import { LiteLockBanner } from '@client/components/_shared/lite/LiteLockBanner';
import { useIsLiteOrg } from '@client/hooks/business/org/useIsLiteOrg';
import { ORG_CONFIG_PERMISSIONS } from '@shared/permissions/permissions';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Shield } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration/compliance')({
    staticData: {
        breadcrumb: {
            title: 'Compliance',
            inactive: true,
        },
        permissions: ORG_CONFIG_PERMISSIONS,
        ui: {
            icon: Shield,
        },
    },
    component: ComplianceConfigurationLayout,
});

function ComplianceConfigurationLayout() {
    // Curium Lite (CUR-379): compliance settings are template-locked — banner on every page;
    // the editors render read-only and the backing mutations are refused server-side.
    const isLiteOrg = useIsLiteOrg();

    return (
        <>
            {isLiteOrg && <LiteLockBanner className="mb-4" />}
            <Outlet />
        </>
    );
}
